// A API devolve por vezes uma lista paginada ({ content: T[] }) e por vezes
// um array simples. Este helper normaliza os dois casos e garante que nunca
// devolvemos algo que não seja array (ex: um objeto de erro com status 200),
// o que crasharia qualquer .map/.filter/.length chamado sobre o resultado.
export function toArray<T = unknown>(data: unknown): T[] {
  if (Array.isArray(data)) return data
  const content = (data as { content?: unknown } | null | undefined)?.content
  if (Array.isArray(content)) return content
  return []
}
